module.exports = __webpack_public_path__ + "img/eve_card_clean.f477c678.png";